import { useEffect, useState } from 'react';
import { FileUpload } from '../../../../components/files/FilesUpload';
import { Image } from 'lucide-react';

interface ImageEstabProps {
    imageId: string;
    setImageId: (imageId: string) => void;
}

export const ImageEstab = ({ imageId, setImageId }: ImageEstabProps) => {
    const [value, setValue] = useState<string[]>(imageId ? [imageId] : []);

    useEffect(() => {
        setImageId(value?.[0] || '');
    }, [value, setImageId]);

    useEffect(() => {
        if (imageId) {
            setValue([imageId]);
        } else if (!imageId && value.length) {
            setValue([]);
        }
    }, [imageId]);

    return (
        <FileUpload value={value} setValue={setValue} multiple={false}>
            {({ fileData, handleChange, inputRef, removeFile, loading }) => {
                const preview = fileData?.[0]?.url || fileData?.[0]?.fileContent;
                const isUploading = Boolean(fileData?.[0]?.uploading);
                return (
                    <div className="flex items-center gap-4 p-4">
                        <div className="estab-thumb relative h-20 w-32 sm:w-40">
                            {preview ? (
                                <img
                                    src={preview}
                                    alt="Logo do estabelecimento"
                                    className="h-full w-full object-contain p-2"
                                />
                            ) : (
                                <span className="flex flex-col items-center gap-1 text-xs text-base-content/45">
                                    <Image className="text-lg" aria-hidden="true" />
                                    Sem logo
                                </span>
                            )}
                            {isUploading && (
                                <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                                    <span className="loading loading-spinner loading-sm text-white"></span>
                                </div>
                            )}
                        </div>

                        <div className="flex flex-col items-start gap-1">
                            <input
                                type="file"
                                ref={inputRef}
                                accept="image/*"
                                onChange={(e: any) => {
                                    const selectedFiles: any = Array.from(e.target.files || []);
                                    handleChange(selectedFiles);
                                }}
                                className="hidden"
                            />
                            <button
                                type="button"
                                className="estab-link-button"
                                disabled={loading}
                                onClick={() => inputRef.current?.click()}
                            >
                                {preview ? 'Alterar logo' : 'Escolher imagem'}
                            </button>
                            {preview && (
                                <button
                                    type="button"
                                    className="estab-link-button estab-link-button--destructive"
                                    disabled={loading}
                                    onClick={() => {
                                        if (fileData?.[0]?.id) {
                                            removeFile(fileData[0].id);
                                        } else {
                                            setValue([]);
                                        }
                                    }}
                                >
                                    Remover
                                </button>
                            )}
                        </div>
                    </div>
                );
            }}
        </FileUpload>
    );
};
